export default __webpack_public_path__ + "static/media/icon_done.76e3ec6b.svg";